import { createPinia } from 'pinia';

export const pinia = createPinia();

// Exportar stores
export * from './sports_centers.store';
export * from './fields.store';
